import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router'
import Header from '../../components/Header'
import { loadParticipantById } from './loadParticipant'
import styles from './index.module.scss'

function getDisplayName(participant: any) {
    const source = participant?.user || participant || {}
    const profile = source.profile || participant?.profile || {}
    return source.full_name || source.name
        || [source.first_name || profile.first_name, source.last_name || profile.last_name].filter(Boolean).join(' ')
        || source.email || participant?.email || ''
}

export default function ParticipantProfile() {
    const navigate = useNavigate()
    const location = useLocation()
    const { userId } = useParams()
    const [searchParams] = useSearchParams()
    const email = searchParams.get('email')
    const query = searchParams.get('query')
    const [participant, setParticipant] = useState<any>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        let active = true
        setParticipant(null)
        setLoading(true)
        setError(false)

        if (!userId) {
            setLoading(false)
            return
        }

        const searchResult = location.state?.participant
        if (searchResult && String(searchResult.id) === userId && searchResult.type === 'user') {
            setParticipant({
                id: searchResult.id,
                name: searchResult.title,
                email: searchResult.subtitle || email || '',
                avatar_url: searchResult.avatarUrl,
            })
            setLoading(false)
            return
        }

        loadParticipantById(userId, email, query)
            .then((result) => {
                if (active) setParticipant(result)
            })
            .catch(() => {
                if (active) setError(true)
            })
            .finally(() => {
                if (active) setLoading(false)
            })

        return () => { active = false }
    }, [userId, email, query, location.state])

    const source = participant?.user || participant
    const displayName = participant ? getDisplayName(participant) : ''
    const displayEmail = source?.email || participant?.email || ''
    const avatar = source?.photo_data_url || participant?.photo_data_url
        || source?.avatar_url || source?.avatar || source?.photo_url
        || source?.photo || source?.profile?.avatar_url || ''

    return (
        <>
            <Header />
            <main className={styles.profile}>
                <div className={styles.heading}>
                    <button type="button" onClick={() => navigate(-1)} className={styles.back}>
                        ← Назад
                    </button>
                    <h1>Профиль участника</h1>
                </div>

                {loading && <p role="status">Загрузка участника...</p>}
                {!loading && error && <p role="alert">Не удалось загрузить участника. Попробуйте позже.</p>}
                {!loading && !error && !participant && <p role="status">Участник не найден.</p>}
                {!loading && !error && participant && (
                    <section className={styles.card} aria-label="Данные участника">
                        {avatar ? (
                            <img className={styles.avatar} src={avatar} alt="" />
                        ) : (
                            <div className={styles.avatar} aria-hidden="true">
                                {displayName.charAt(0).toUpperCase()}
                            </div>
                        )}
                        <div className={styles.details}>
                            <h2>{displayName}</h2>
                            {displayEmail && <a href={`mailto:${displayEmail}`}>{displayEmail}</a>}
                        </div>
                    </section>
                )}
            </main>
        </>
    )
}
